export default __webpack_public_path__ + "static/media/IMG_4711.8544e734.JPG";